/**
 * Removes `item` from `array`
 *
 * @return * Item removed from the array
 * @ignore
 */
export const remove = (array: unknown[], item: unknown): unknown => {
  const i = array.indexOf(item);
  if (i >= 0) {
    return array.splice(i, 1)[0];
  }

  return undefined;
};
